import React from "react";
import { Button, Image, Table, Popup } from "semantic-ui-react";
import _ from "lodash";
import PersonRecordHeader from "../searchresults/PersonRecordHeader";
import yesImage from "../../assets/images/yes.jpg";
import CheckIcon from "../../assets/images/check_36x36.png";
import HomeValue from "../../assets/images/homeval.jpg.png";
import Income from "../../assets/images/incomeNew.png";
import Pin from "../../assets/images/pin.png";
import { getFormattedPhone } from "../common/Phone";

const getAkas = (akas) =>
  akas.map((aka, akaIndex) => (
    <span key={`name_${akaIndex}`}>
      {aka}
      <br />
    </span>
  ));

const getSsnRisks = (ssnRisks) =>
  ssnRisks.map((ssnRisk, ssnRiskIndex) => (
    <li key={`ssn_risk_${ssnRiskIndex}`}>{ssnRisk}</li>
  ));

const getAddress = (addressText, address, props) => {
  const { city, state, zipcode } = address;
  if (city === "" && addressText === "") {
    return <span />;
  }
  return (
    <span
      role="button"
      tabIndex={0}
      className={"background-color-transparent url-link"}
      onClick={() =>
        props.handleNewSearchClick(this, "Address", addressText, address)
      }
    >
      {`${addressText},`} <br /> {`${city}, ${state} ${zipcode}`}
    </span>
  );
};

const getAddressIcons = (addressText, addressData, props) => {
  const { address, zipcode, city, state } = addressData;
  if (city === "" && addressText === "") {
    return <span />;
  }
  const mapAddress = `${address && address.replace(" ", "+")}+${zipcode}`;
  return (
    <span>
      <span className={`no-print`}>
        <Popup
          trigger={
            <Image
              className={"icon-display-link"}
              src={HomeValue}
              onClick={
                state !== ""
                  ? () => props.handleHomeValueClick(this, zipcode, address)
                  : null
              }
              spaced
            />
          }
          position="top center"
        >
          <span className="address-icons-tooltip">
            Click to see home value demographics
          </span>
        </Popup>
        <Popup
          trigger={
            <Image
              className={"icon-display-link"}
              src={Income}
              onClick={
                state !== ""
                  ? () => props.handleHomeIncomeClick(this, zipcode, address)
                  : null
              }
              spaced
            />
          }
          position="top center"
        >
          <span className="address-icons-tooltip">
            Click to see income demographics
          </span>
        </Popup>
        <Popup
          trigger={
            <Image
              src={Pin}
              className={"icon-display-link"}
              onClick={
                state !== ""
                  ? () => props.handleMapClick(this, mapAddress)
                  : null
              }
              spaced
            />
          }
          position="top center"
        >
          <span className="address-icons-tooltip">Click to view map</span>
        </Popup>

        <br />
      </span>
    </span>
  );
};

const getAddressAndPhones = (
  addressPhoneData,
  props,
  // isSilverSearch,
  // isGoldSearch
) => {
  const addRows = [];
  _.forEach(addressPhoneData, (addPhoneData) => {
    _.forEach(addPhoneData, (data, addPhoneIndex) => {
      const phones = [];
      const historicalPhones = [];
      _.forEach(data.phones, (phoneData, phoneIndex) => {
        const score = phoneData.score;
        const phone =
          // isSilverSearch || isGoldSearch
          // ? 
          getFormattedPhone(phoneData.phone);
        // : phoneData.phone;
        if (score > 19) {
          if (score > 80) {
            phones.push(
              <span key={`score_gt_80_${addPhoneIndex}_${phoneIndex}`}>
                {phone}{" "}
                <Image src={yesImage} className={"icon-size-small"} inline />
                <br />
              </span>
            );
          } else if (score < 60) {
            historicalPhones.push(
              <span key={`score_lt_60_${addPhoneIndex}_${phoneIndex}`}>
                {phone}
                <br />
              </span>
            );
          } else {
            phones.push(
              <span key={`score_bt_80_60_${addPhoneIndex}_${phoneIndex}`}>
                {phone}
                <br />
              </span>
            );
          }
        } else {
          phones.push(
            <span key={`no_score_${addPhoneIndex}_${phoneIndex}`}>
              {phone}
              <br />
            </span>
          );
        }
      });
      const colorClass = addPhoneIndex % 2 === 0 ? "odd-row" : "even-row";
      const { recType, dateRange, addressData } = data;
      addRows.push(
        <Table.Row
          key={`Person_Record_Address_Row_${addPhoneIndex}`}
          className={colorClass}
        >
          <Table.Cell className={"table-no-padding"} width={3}>
            {dateRange}
          </Table.Cell>
          <Table.Cell width={1}>
            {(recType === "Best" ||
              recType === "V" ||
              recType === "C" ||
              recType === "ncoa") && (
                <img src={CheckIcon} alt="check" width="20px" height="20px" />
              )}
          </Table.Cell>
          <Table.Cell className={"table-no-padding"} width={8}>
            {addressData &&
              getAddressIcons(
                addressData.addressText,
                addressData.address,
                props
              )}
            {addressData &&
              getAddress(addressData.addressText, addressData.address, props)}
          </Table.Cell>
          <Table.Cell className={"table-no-padding"} width={4}>
            {(phones.length > 0 || historicalPhones.length > 0) && (
              <span key={"phone_det"}>
                {phones}
                {historicalPhones}
              </span>
            )}
          </Table.Cell>
        </Table.Row>
      );
    });
  });

  return (
    <Table.Row key={"add_phone_det"}>
      <Table.Cell key={"address_det"}>
        <Table className={"table-no-border-and-padding"}>
          <Table.Body>{addRows}</Table.Body>
        </Table>
      </Table.Cell>
    </Table.Row>
  );
};

const onCheckFullSsn = (internalID, displaySsn, props) => {
  const data = props.formData;
  data.internalID = internalID;
  data.revealSSN = displaySsn;
  data.updateAddress = "byAKA";
  data.searchByOpt = "People";
  const root = Object.keys(props.searchResultData)[0];
  let actId = _.get(props.searchResultData, `${root}.log[0].actID[0]`);
  if (!actId) actId = _.get(props.searchResultData, `${root}.log[0].xmlID[0]`);
  if (actId && actId !== "") data.savedResultID = actId;
  props.showResults(this, data);
};

export const getPersonDetailElement = (
  row,
  reportId,
  selectedReportId,
  props,
  revealSsnReportCost,
  onSelectPersonReport,
  isSilverSearch,
  isGoldSearch,
  showDetailReport
) => {
  const id = row.internalID;
  const {
    showCheckFullSsn,
    displaySsn,
    // ssn,
    internalID,
    fullSsnInfo,
    dod,
    age,
    akas,
    ssnRisks,
    addressPhoneData,
    dob,
    ssnState,
    ssnYear,
    ageAtDeath,
  } = row;
  const element = (
    <Table
      id={`per_rec_${id}`}
      className="table-no-border background-color-transparent"
      key={`Person_record_${row.recId}`}
    >
      <Table.Body>
        <Table.Row key={`Person_Header_Detail_Row_${id}`}>
          <Table.Cell>
            <PersonRecordHeader
              key={`PersonHeader_Table_${id}`}
              // node={cell.personRes}
              name={row.name}
              nameCollections={row.nameCollections}
              internalID={row.internalID}
              resultRootNodeName={
                props.resultRootNodeName
                  ? props.resultRootNodeName
                  : Object.keys(props.searchResultData)[0]
              }
              index={id}
              selectedReportId={selectedReportId}
              onSelectPersonReport={onSelectPersonReport}
              showDetailReport={showDetailReport}
              isSilverSearch={isSilverSearch}
              isGoldSearch={isGoldSearch}
              {...props}
            />
          </Table.Cell>
        </Table.Row>
        <Table.Row key={`PersonDetail_Table_Row_${id}`}>
          <Table.Cell>
            <Table className={"table-no-border-and-padding"}>
              <Table.Body>
                <Table.Row key={`Person_Search_Details_${props.index}`}>
                  <Table.Cell width={4} className={"border-right"}>
                    <div className={"padding-10"}>
                      <span className="text-bold">SSN:</span>
                      {(displaySsn !== "N/A" &&
                        displaySsn.toLowerCase().indexOf("x") === -1 ? (
                        <span
                          role="button"
                          tabIndex={0}
                          onClick={() =>
                            props.handleNewSearchClick(
                              this,
                              "SSN",
                              displaySsn,
                              {
                                displaySsn,
                              }
                            )
                          }
                          className={"url-link"}
                        >
                          {displaySsn}
                        </span>
                      ) : (
                        displaySsn
                      ))}
                      {props.formData &&
                        props.formData.internalID === internalID &&
                        (ssnState || ssnYear) && (
                          <span>
                            <br />
                            Issued: {ssnYear || ""}{" "}
                            {ssnYear && ssnState ? ` in ${ssnState}` : ssnState}
                          </span>
                        )}
                      {(showCheckFullSsn &&
                        showDetailReport &&
                        displaySsn !== "N/A"
                        ? !props.ignoreSsnButton && (
                          <span className={`no-print`}>
                            <br />
                            <Button
                              className="sublink_button"
                              onClick={() =>
                                onCheckFullSsn(
                                  internalID,
                                  displaySsn,
                                  props
                                )
                              }
                            >
                              Check for full SSN{" "}
                              {revealSsnReportCost !== "$0.00"
                                ? ` - ${revealSsnReportCost}`
                                : ""}
                            </Button>
                          </span>
                        )
                        : fullSsnInfo)}
                      {dob && (
                        <span>
                          <br />
                          DOB: {dob}
                        </span>
                      )}
                      {(isSilverSearch || isGoldSearch) &&
                        (dod === undefined || dod === "N/A") &&
                        age && (
                          <span>
                            {" "}
                            <br />
                            <span className="text-bold">Age:</span> {age}
                          </span>
                        )}
                      {!(isSilverSearch || isGoldSearch) &&
                        ((dod === undefined || dod === "N/A") &&
                          age !== undefined ? (
                          <span>
                            {" "}
                            <span className="text-bold">
                              <br />
                              Age:
                            </span>{" "}
                            {age}
                          </span>
                        ) : null)}
                      {(isSilverSearch || isGoldSearch) &&
                        (dod !== undefined && dod !== "N/A" ? (
                          <span>
                            {" "}
                            <span className="text-bold">
                              <br />
                              DOD:{" "}
                            </span>{" "}
                            {dod}
                          </span>
                        ) : null)}
                      {(isSilverSearch || isGoldSearch) &&
                        (dod !== undefined && dod !== "N/A" ? (
                          <span>
                            {" "}
                            <span className="text-bold">
                              <br />
                              Age at Death:{" "}
                            </span>{" "}
                            {ageAtDeath}
                          </span>
                        ) : null)}
                      {akas.length > 0 ? (
                        <span>
                          <span className="text-bold">
                            <br />
                            Possible Names(AKAs):
                            <br />
                          </span>
                          {getAkas(akas)}
                        </span>
                      ) : null}
                      {!(isSilverSearch || isGoldSearch) && ssnRisks.length > 0 && (
                        <ul key="ssn_risks">{getSsnRisks(ssnRisks)}</ul>
                      )}
                    </div>
                  </Table.Cell>
                  <Table.Cell width={12}>
                    <Table className={"icon-align-middle table-no-border"}>
                      <Table.Body>
                        {getAddressAndPhones(
                          addressPhoneData,
                          props,
                          isSilverSearch,
                          isGoldSearch
                        )}
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
  return element;
};

export default getPersonDetailElement;



// WEBPACK FOOTER //
// ./src/components/searchresults/PersonDetailElement.js